<script setup>
import { defineProps } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps({
  productIndex: {
    type: Number,
    required: true,
  },
  productsLength: {
    type: Number,
    required: true,
  },


})
const router = useRouter();

function backToMain() {
  router.push('/')
}

</script>

<template>
  <div>
    <div class="btn-toolbar" role="toolbar">
      <template v-if="productIndex">
        <div class="btn-group btn-group-text">
          {{ productIndex }}/{{ productsLength }}
        </div>
      </template>
      <div class="btn-group btn-group-back" role="group">
        <button @click="backToMain"
                id="productPageBackButton"
                class="btn btn-primary"
        >
          <span class="glyphicon glyphicon-backward"></span>
        </button>
      </div>
      <div class="btn-group btn-group-back" role="group">
        <button @click="$emit('go-to-prev-product')"
                :disabled="productIndex === 1"
                class="btn btn-primary">
          <span class="glyphicon glyphicon-chevron-left"></span>
        </button>
      </div>
      <div class="btn-group" role="group">
        <button @click="$emit('go-to-next-product')"
                :disabled="productIndex === productsLength"
                class="btn btn-primary">
          <span class="glyphicon glyphicon-chevron-right"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>